<template>
  <div>
    <RepeatableFormGroup
        :value="value.items"
        label="Items"
        help-text="Add menu items to the menu block."
        empty-text="No items added."
        :errors="itemErrors"
        @input="emit('items', $event)"
    >
      <template v-slot:default="{ data, index, change, errors }">
        <div class="row">
          <div class="col-xs-12">
            <TextFormGroup
                :value="data.text"
                name="text"
                label="Text"
                :error="(errors.text || [])[0]"
                @input="change(index, 'text', $event)"
            />
          </div>

          <div class="col-xs-12">
            <TextFormGroup
                :value="data.path"
                name="path"
                label="Path"
                :error="(errors.path || [])[0]"
                @input="change(index, 'path', $event)"
            />
          </div>
        </div>
      </template>
    </RepeatableFormGroup>
  </div>
</template>

<script>
import SelectFormGroup from '@/vendor/forms/FormGroups/Block/Select'
import TextFormGroup from '@/vendor/forms/FormGroups/Block/Text'
import RepeatableFormGroup from "../../../Forms/RepeatableFormGroup.vue";

export default {
  components: {RepeatableFormGroup, SelectFormGroup, TextFormGroup},

  props: {
    value: {
      required: true
    },

    errors: {
      required: true
    }
  },

  methods: {
    emit(key, value) {
      this.$emit('input', {...this.value, [key]: value})
    },
  },

  computed: {
    itemErrors() {
      return Object.entries(this.errors)
          .filter(entry => entry[0].startsWith('items.'))
          .reduce((result, entry) => ({
            ...result,
            [entry[0].substring('items.'.length)]: entry[1]
          }), {})
    }
  },
}
</script>
